// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__oSxsk","balanceDisclaimer":"posDashboard_balanceDisclaimer__3UHBK"};